import type { IRogue } from "../services/RogueTypes"

export type Newsletter = {
  label : string,
  name : string,
  id : number,
  selected : boolean,
  // Optional "What's This?" copy - rendered as a tooltip next to the checkbox
  tooltip? : string,
}

export default function getNewsletterList(rogue: IRogue, onlyMainNewsletters: boolean, fullLabel: boolean) {
  const newsletters: Newsletter[] = [
    {
      label    : `Newsletter${fullLabel ? ' - (Stay up to date with Rogue news, events, and products)' : ''}`,
      name     : 'newsletter',
      id       : rogue.keys.iterable.newsletter,
      selected : false,
      tooltip  : 'Get Rogue News, product releases and events.',
    },
    {
      label    : `Rapidfire${fullLabel ? ' - (Be the first to know when new products and Hot Deals are launched)' : ''}`,
      name     : 'rapidfire',
      id       : rogue.keys.iterable.rapidfire,
      selected : false,
      tooltip  : 'Be the first to know when new products and Hot Deals are launched.',
    },
  ]

  if (onlyMainNewsletters) {
    return newsletters
  }

  if (rogue.keys.iterable.invitationalNewsUpdates) {
    newsletters.push(
      {
        label    : 'Rogue Invitational - News and Updates',
        name     : 'invitationalNewsUpdates',
        id       : rogue.keys.iterable.invitationalNewsUpdates,
        selected : false,
      }
    )
  }

  if (rogue.keys.iterable.invitationalTickets) {
    newsletters.push(
      {
        label    : 'Rogue Invitational - Tickets',
        name     : 'invitationalTickets',
        id       : rogue.keys.iterable.invitationalTickets,
        selected : false,
      }
    )
  }

  if (rogue.keys.iterable.invitationalVolunteering) {
    newsletters.push(
      {
        label    : 'Rogue Invitational - Volunteering',
        name     : 'invitationalVolunteering',
        id       : rogue.keys.iterable.invitationalVolunteering,
        selected : false,
      }
    )
  }

  if (rogue.keys.iterable.invitationalVendors) {
    newsletters.push(
      {
        label    : 'Rogue Invitational - Vendors',
        name     : 'invitationalVendors',
        id       : rogue.keys.iterable.invitationalVendors,
        selected : false,
      }
    )
  }

  return newsletters
}
